import { render, staticRenderFns } from "./MapaPontos.vue?vue&type=template&id=b8a134a0&scoped=true&lang=pug&"
import script from "./MapaPontos.vue?vue&type=script&lang=js&"
export * from "./MapaPontos.vue?vue&type=script&lang=js&"
import style0 from "./MapaPontos.vue?vue&type=style&index=0&id=b8a134a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a134a0",
  null
  
)

export default component.exports